<template>
  <div>
    <el-row :gutter="10" class="u-mt-10 u-mb-20">
      <el-col :xs="24" :sm="10">
        <el-input v-model="filtro.nome" placeholder="Pesquisar por nome ou CRN" @keyup.native.enter="load"></el-input>
      </el-col>
      <el-col :xs="24" :sm="6">
        <el-select v-model="filtro.vinculo" placeholder="Vínculo" clearable @change="load" style="width:100%">
          <el-option label="INTERNO (servidor)" value="interno"></el-option>
          <el-option label="EXTERNO" value="externo"></el-option>
        </el-select>
      </el-col>
      <el-col :xs="24" :sm="8" class="u-text-right">
        <el-button class="u-mr-10" @click="load" type="info" plain icon="el-icon-search">FILTRAR</el-button>
        <router-link to="/admin/merenda/nutricionista/cadastro" class="btn-new-register" v-if="podeEscrever">
          <el-button type="primary">NOVO NUTRICIONISTA</el-button>
        </router-link>
      </el-col>
    </el-row>

    <div class="container-table">
      <table class="table table-striped">
        <thead>
          <tr>
            <th class="hidden-mobile" style="width:70px;">cod</th>
            <th>Nome</th>
            <th style="width:130px;">CRN</th>
            <th class="hidden-mobile" style="width:120px;">Vínculo</th>
            <th class="hidden-mobile u-text-center" style="width:80px;">Ativo</th>
            <th style="width:140px;" class="u-text-center" v-if="podeEscrever">Ação</th>
          </tr>
        </thead>
        <tbody v-if="statusList">
          <tr v-for="item in items" :key="item.id">
            <td class="hidden-mobile">{{ item.id }}</td>
            <td>{{ item.nome_exibicao || '—' }}</td>
            <td>{{ item.crn ? item.crn + (item.uf_crn ? '/' + item.uf_crn : '') : '—' }}</td>
            <td class="hidden-mobile">
              <el-tag size="mini" :type="item.vinculo === 'interno' ? 'success' : 'info'">
                {{ item.vinculo === 'interno' ? 'SERVIDOR' : 'EXTERNO' }}
              </el-tag>
            </td>
            <td class="hidden-mobile u-text-center">{{ item.situacao ? 'SIM' : 'NÃO' }}</td>
            <td class="u-text-center acao" v-if="podeEscrever">
              <router-link :to="'/admin/merenda/nutricionista/edit/' + item.id" class="link-icon u-mr-10" style="color: rgba(0, 0, 0, 0.87) !important;">
                <el-button type="info" title="Editar" icon="el-icon-edit" size="mini" plain></el-button>
              </router-link>
              <el-button @click="deleteItem(item.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
            </td>
          </tr>
          <tr v-if="items.length === 0">
            <td :colspan="podeEscrever ? 6 : 5" class="u-text-center">Nenhum nutricionista cadastrado.</td>
          </tr>
        </tbody>
      </table>

      <el-row v-if="statusList">
        <el-col :xs="24" :sm="12">
          <div class="u-mt-10"><small v-if="paginate.qtdItens">Exibindo {{ paginate.from }} a {{ paginate.to }} de {{ paginate.qtdItens }}</small></div>
        </el-col>
        <el-col :xs="24" :sm="12" v-if="paginate.qtdItens > 15">
          <div class="u-text-right">
            <el-pagination :current-page="paginate.page" class="u-mt-10" :total="paginate.qtdItens"
              @current-change="getPagePagination" :page-size="15" background layout="prev, pager, next" small></el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    statusList: false,
    filtro: { nome: '', vinculo: '' },
    paginate: { page: 1, qtdItens: null, from: '', to: '' },
    items: []
  }),
  computed: {
    podeEscrever () { return [4, 5, 6].indexOf(Number(this.$store.state.user.tipo)) !== -1 }
  },
  mounted () { this.load() },
  methods: {
    load () {
      this.statusList = false
      this.items = []
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/nutricionista/getAllPaginate?page=` + this.paginate.page, this.filtro, this.$store.getters.getHeaderAuth)
        .then(response => {
          this.items = response.data.data
          this.paginate.qtdItens = response.data.total
          this.paginate.from = response.data.from
          this.paginate.to = response.data.to
          this.statusList = true
        }).catch((error) => { this.$store.commit('throwException', error) })
    },
    deleteItem (id) {
      this.$msgbox.confirm('Tem certeza que deseja excluir este nutricionista?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' })
        .then(() => {
          window.eventBus.$emit('loading', true)
          this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/merenda/nutricionista/delete/` + id, this.$store.getters.getHeaderAuth)
            .then(response => {
              window.eventBus.$emit('loading', false)
              if (response.data && response.data.erro) {
                return window.eventBus.$emit('alert', { msg: response.data.erro, type: 'warning' })
              }
              window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
              this.load()
            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
        }).catch(() => { })
    },
    getPagePagination (page) { this.paginate.page = page; this.load() }
  }
}
</script>
